










































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePressure from "./createpressure.vue";
import EditPressure from "./editpressure.vue";
import CopyPressure from "./copypressure.vue";
import ImportData from "./importpressure.vue";
import AuthorizeDevice from "./authorizedevice.vue";
import ReplaceDeviceId from "@/views/basedatas/deviceTenant/replacedeviceId.vue";
import Moment from "moment-timezone";
import checkAuth from "@/lib/Common/checkauth";

class PagePressureModelRequest extends PageRequest {
  keyword: string;
  areaId: number;
  supplierId: number;
  deviceType: number;
  isEnabel: number;
}

@Component({
  components: {
    CreatePressure,
    EditPressure,
    CopyPressure,
    ImportData,
    AuthorizeDevice,
    ReplaceDeviceId,
  },
})
export default class pressure extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PagePressureModelRequest = new PagePressureModelRequest();
  creationTime: Date[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  collectorList: any[] = [];
  modelType: any[] = [];
  choosepressure: Array<any> = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  importModalShow: boolean = false;
  autorizeModalShow: boolean = false;
  height: number = 300;
  loadingdata: boolean = false;
  splitnum: number = 0.15;
  deviceId: string = "";
  deviceModalShow: boolean = false; //更新表计平台Id

  //更换平台Id
  async replacedeviceid(deviceId: string) {
    // let val = (this.$refs.selection as any).getSelection();
    // if (val.length == 0 || val.length > 1) {
    //   this.$Modal.info({
    //     title: this.L("Tips"),
    //     content: this.L("PleasChoose") + this.L("Meter"),
    //   });
    //   return;
    // }
    this.deviceId = deviceId;
    this.deviceModalShow = true;
  }

  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.pressure.list;
  }
  get loading() {
    return this.$store.state.pressure.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: number) {
    this.$store.commit("pressure/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("pressure/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let device = detaillist.filter((p) => {
        return p.itemId == 17;
      });
      device.forEach((ele) => {
        this.$data.deviceType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  pageChange(page: number) {
    this.$store.commit("pressure/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("pressure/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "pressure/getAll",
      data: this.pagerequest,
    });
  }
  async getCollectorList() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.collectorList.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  get pageSize() {
    return this.$store.state.pressure.pageSize;
  }
  get totalCount() {
    return this.$store.state.pressure.totalCount;
  }
  get currentPage() {
    return this.$store.state.pressure.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      width: 160,
      fixed: "left",
      sortable: true,
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "collectorId",
      width: 130,
      sortId: 7,
      render: (h: any, params: any) => {
        let id = params.row.collectorId;
        let info = this.collectorList.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].no : this.L("DirectLink"),
            },
          },
          info.length > 0 ? info[0].no : this.L("DirectLink")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ModelInfo"),
      key: "modelId",
      width: 130,
      sortId: 18,
      render: (h: any, params: any) => {
        let id = params.row.modelId;
        let info = this.modelType.filter((p) => {
          return p.value == id;
        });
        return h("span", info.length > 0 ? info[0].label : this.L("Unknown"));
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      sortId: 17,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Imei"),
      key: "imei",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.imei },
            },
            params.row.imei
          ),
        ]);
      },
    },
    {
      title: this.L("IMSI"),
      key: "iMSI",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.iMSI },
            },
            params.row.iMSI
          ),
        ]);
      },
    },
    {
      title: this.L("ICCID"),
      key: "iCCID",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.iCCID },
            },
            params.row.iCCID
          ),
        ]);
      },
    },
    {
      title: this.L("MeterType"),
      key: "meterType",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.meterType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceType",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("ISP"),
      key: "iSP",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Transfer") + this.L("Category"),
      key: "transferType",
      width: 130,
      sortable: true,
      sortId: 21,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("IsSec"),
      key: "isSec",
      width: 90,
      sortId: 29,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isSec == true ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("AesKey"),
      key: "aesKey",
      width: 130,
      sortId: 30,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.aesKey },
            },
            params.row.aesKey
          ),
        ]);
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appId },
            },
            params.row.appId
          ),
        ]);
      },
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("AepTenantId"),
      key: "aepTenantId",
      width: 130,
    },
    {
      title: this.L("ProductId"),
      key: "productId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.productId },
            },
            params.row.productId
          ),
        ]);
      },
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("ManufacturerId"),
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("ManufacturerName"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("DeviceModel"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Obj_Id"),
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Obj_Inst_id"),
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Res_Id"),
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("Supplier"),
      key: "supplierId",
      width: 130,
      sortable: true,
      sortId: 20,
      render: (h: any, params: any) => {
        let id = params.row.supplierId;
        let ite = JSON.parse(localStorage.getItem("suppliers"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("ISPDeviceId"),
      key: "ispDeviceId",
      width: 130,
      sortId: 46,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.ispDeviceId },
            },
            params.row.ispDeviceId
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      sortId: 45,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
      sortId: 47,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 48,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
    {
      title: "Id",
      key: "id",
      width: 130,
      sortId: 49,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.id },
            },
            params.row.id
          ),
        ]);
      },
    },
    {
      title: this.L("Unit"),
      key: "unitName",
      width: 130,
      sortId: 51,
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      width: 130,
      sortId: 52,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 230,
      fixed: "right",
      sortId: 50,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('pressureDel');
        let edit = this.checkButtonAuth('pressureEdit');
        let copy = this.checkButtonAuth('pressureCopy');;
        let replacePlateformId = this.checkButtonAuth('pressureReplace');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("pressure/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "pressure/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
          copy ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("pressure/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          replacePlateformId ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.replacedeviceid(params.row.id);
                },
              },
            },
            this.L("ReplacePlateFormId")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    await this.getCollectorList();
    await this.getmodelType();
    await this.getSupplier();
    this.getAreaTree();
    this.getpage();
  }
  //模型Id
  async getmodelType() {
    await this.$store
      .dispatch("pressuremodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //供应商
  async getSupplier() {
    await this.$store
      .dispatch("supplier/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.suppliers.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list });
    }
  }
  data() {
    return {
      ispdetail: [],
      deviceType: [],
      suppliers: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //复制
  async copy() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("PressureModal"),
      });
      return;
    }
    let pressureId: string = null;
    if (val.length > 0) {
      val.forEach((ele) => {
        pressureId = ele.id;
        return pressureId;
      });
    }
    if (pressureId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("PressureModal"),
      });
    }
    let res = await this.$store.dispatch({
      type: "pressure/get",
      id: pressureId,
    });
    this.$store.commit("pressure/edit", res);
    this.copyModalShow = true;
  }
  //取消注册
  async cancelregister() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        meterId.push(ele.id);
      });
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Customer"),
      });
    }
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "pressure/cancelRegisterPressure",
        data: meterId,
      })
      .catch((err) => {
        this.loadingdata = false;
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loadingdata = false;
    this.getpage();
  }
  //注册
  async register() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    let checkVal: number = 0;
    if (val.length > 0) {
      val.forEach((ele) => {
        if (ele.transferType != 34) {
          checkVal = 1;
          return;
        }
        meterId.push(ele.id);
      });
    }
    if (checkVal == 1) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("NoLink"),
      });
      return;
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "pressure/registerPressure",
        data: meterId,
      })
      .catch((err) => {
        this.loadingdata = false;
      });
    //console.log(res)
    this.loadingdata = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.getpage();
  }
  //导入数据
  ImportData() {
    this.importModalShow = true;
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 350;
    } else {
      this.height = window.innerHeight - 100;
    }
  }
  //授权设备
  authorizedevice() {
    let val = (this.$refs.selection as any).getSelection();
    this.choosepressure = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        this.choosepressure.push(ele.id);
      });
    }
    this.autorizeModalShow = true;
  }
  //选择
  onrowselect(val, index) {
    this.choosepressure.push(index.id);
  }
  //取消选择
  onrowselected(val, index) {
    this.choosepressure = this.choosepressure.filter((ele) => ele != index.id);
  }
  //全选
  handall(selection) {
    if (selection.length > 0) {
      this.choosepressure = [];
      selection.forEach((ele) => {
        this.choosepressure.push(ele.id);
      });
    }
  }
  //取消全选
  handallcancel(selection) {
    this.choosepressure = [];
  }
}
